const createActions = require('./').default;

let store;

module.exports = createActions(payload => store.dispatch(payload)).actions;
module.exports.setStore = _store => (store = _store);
